import React from 'react';
import { EnumMediaType } from '../index';
import { useMessageManagerProvider } from '../../../../../../../../../context/messageManager';
import { Input } from '../../../../../../../../../../components/Common/UI/Input';
import Checkbox from '../../../../../../../../../../components/Common/UI/Checkbox';
import { Button } from '../../../../../../../../../../components/Common/UI/Button';
import Icons from '../../../../../../../../../../components/Common/Icons/Icons';

interface ISelectedItem {
  currentTab: EnumMediaType;
}

function SelectedItem({ currentTab }: ISelectedItem) {
  const { selectedImage, handleSelectedImage } = useMessageManagerProvider();

  return (
    <div className="p-[20px] bg-white rounded-lg">
      <div
        className="bg-lightGray2 flex items-center mb-[20px] h-[390px] w-[390px] rounded-lg border overflow-hidden
      justify-center"
      >
        <img
          src={
            currentTab === 'images'
              ? selectedImage?.imageUrl || '/infoTrac/images/step-2-img-3.png'
              : '/infoTrac/images/step-2-QR.png'
          }
          alt="selected"
          className="h-full object-contain"
        />
      </div>
      {currentTab === 'images' ? (
        <div className="grid gap-[10px]">
          <Input placeholder="Type here..." label="ADA Message" />
          <Input placeholder="Type here..." label="Click Through URL" />
          <div className="flex gap-2 items-center opacity-70">
            <Checkbox
              id="qrCodeCheckbox"
              onClick={() => {
                if (selectedImage) {
                  handleSelectedImage({ ...selectedImage, qrCode: !selectedImage?.qrCode });
                }
              }}
            />
            <label htmlFor="qrCodeCheckbox" className="text-sm text-primary cursor-pointer">
              QR Code Upload
            </label>
          </div>
        </div>
      ) : (
        <div className="grid gap-[10px]">
          <Input placeholder="Type here..." label="QR Code" />
          <div className="grid grid-cols-2 gap-[20px]">
            <Input placeholder="1024" label="Width" prefix="px" maxLength={6} />
            <Input placeholder="1024" label="Hight" prefix="px" maxLength={6} />
          </div>
          <Input placeholder="Type here..." label="Name" maxLength={40} />
          <Button className="bg-primary w-[175px] p-[10px_20px]">
            <Icons.PlusFilled />
            Add to Library
          </Button>
          <div className="border rounded-lg p-[10px] text-primary bg-lightGray2">
            <div className="font-bold">Instructions:</div>
            <div>
              <span className="font-bold mr-[3px]">1. Image format accepted:</span>
              TIFF, JPEG, PNG
            </div>
            <div>2. Image size should not exceed 5 MB</div>
            <div>3. Only RGB color model is accepted. (i.e. CMYK color model not accepted)</div>
            <div className="font-bold">4. Max 40 characters supported in name field</div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SelectedItem;
